import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { NotificationActionResultDto } from './dtos/notification-action-result.dto';
import { NotificationActionResultMapper } from './mappers/notification-action-result.mapper';
import { NotificationActionApplyResult } from '../state/notification.model';

// Hits api_platform directly at pureSpectrum.url — the execution endpoints
// live there, not behind the notification-svc gateway (see notification.api.ts).
@Injectable({ providedIn: 'root' })
export class NotificationActionApi {
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _httpClient = inject(HttpClient);
  private readonly _resultMapper = new NotificationActionResultMapper();

  public apply(
    surveyId: string,
    commentId: string,
    actionId: string,
  ): Observable<NotificationActionApplyResult> {
    return this._post(surveyId, commentId, actionId, 'apply');
  }

  public undo(
    surveyId: string,
    commentId: string,
    actionId: string,
  ): Observable<NotificationActionApplyResult> {
    return this._post(surveyId, commentId, actionId, 'undo');
  }

  private _post(
    surveyId: string,
    commentId: string,
    actionId: string,
    operation: 'apply' | 'undo',
  ): Observable<NotificationActionApplyResult> {
    const url = `${this._environmentConfig.pureSpectrum.url}/surveys/${surveyId}/comments/${commentId}/actions/${actionId}/${operation}`;

    return this._httpClient
      .post<NotificationActionResultDto>(url, {})
      .pipe(map((resultDto) => this._resultMapper.fromDto(resultDto)));
  }
}
